import request from './request';

export const userApi = {
  // 登录
  login(credentials) {
    return request.post('/users/login', credentials);
  },
  
  // 登出
  logout() {
    return request.post('/users/logout');
  },
  
  // 注册
  register(userData) {
    return request.post('/users/register', userData);
  },
  
  // 发送注册验证码
  sendRegisterCode(email) {
    return request.post('/users/send-register-code', { email });
  },
  
  // 获取个人资料
  getProfile() {
    return request.get('/users/profile');
  },
  
  // 更新个人资料
  updateProfile(data) {
    return request.put('/users/profile', data);
  },
  
  // 修改密码
  changePassword(data) {
    return request.put('/users/password', data);
  },
  
  // 上传头像
  uploadAvatar(formData) {
    return request.post('/users/avatar', formData);
  },
  
  // 忘记密码
  forgotPassword(email) {
    return request.post('/users/forgot', { email });
  },
  
  // 重置密码
  resetPassword(data) {
    return request.post('/users/reset', data);
  },
  
  // 刷新 Token
  refreshToken() {
    return request.post('/users/refresh');
  }
};
